/** @format */

import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Chain, Environment } from '@shared/data-access/interfaces';
import { WINDOW } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class ReservationsGuard {
	constructor(
		private readonly chain: Chain,
		private readonly environment: Environment,
		private readonly router: Router,
		@Inject(WINDOW) protected window: Window
	) {}

	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const eventReservationsEnabled =
			typeof this.window['eventReservationsEnabled'] !== 'undefined'
				? this.window['eventReservationsEnabled']
				: this.environment.killSwitch.eventReservationsEnabled[
						this.chain.chainIdentifierAbbr
					];

		if (eventReservationsEnabled) {
			return true;
		}

		this.router.navigate(['/MyAccount/AccountSummary']);
		return false;
	}
}
